import { Injectable } from '@angular/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { ProdutoSugerido } from '../models/produto-sugerido.model';
import { ConfiguracaoService } from './configuracao.service';
import { IConfiguracao } from '../models/configuracao.model';
import { HttpResponse } from '@angular/common/http';
import { DadosUsuario, IDadosUsuario } from '../models/dados-usuario.model';
import { DadosUsuarioService } from './dados-usuario.service';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UtilsCompraService {
    produtosCarrinho = new BehaviorSubject<any>(0);
    isLoading = false;
    configuracao: IConfiguracao;
    errors;
    dadosUsuario: IDadosUsuario = new DadosUsuario();
    isSancorClientes: boolean = false;
    constructor(
        private $localStorage: LocalStorageService,
        private $sessionStorage: SessionStorageService,
        protected configuracaoService: ConfiguracaoService,
        protected dadosUsuarioService: DadosUsuarioService,
        protected router: Router,
    ) {
    }

    getCarrinho(): ProdutoSugerido[] {
        const carrinhoLocal: ProdutoSugerido[] | null =
            this.$localStorage.retrieve("carrinhocompras");
        const carrinhoSession: ProdutoSugerido[] | null =
            this.$sessionStorage.retrieve("carrinhocompras");
        this.produtosCarrinho.next(carrinhoLocal ?? carrinhoSession ?? []);
        return carrinhoLocal ?? carrinhoSession ?? [];
    }

    saveToCart(produtoscarrinho) {
        this.$localStorage.store("carrinhocompras", produtoscarrinho);
        this.$sessionStorage.store("carrinhocompras", produtoscarrinho);
    }

    loadConfigurations() {
        this.isLoading = true;
        this.configuracaoService.findConfigSite().subscribe(
            (res: HttpResponse<IConfiguracao>) => {
                this.isLoading = false;
                this.configuracao = res.body ?? null;
            },
            () => {
                this.isLoading = false;
            }
        );
    }

    buscaDadosUsuario() {
        this.dadosUsuarioService.query().subscribe(
            (res: HttpResponse<IDadosUsuario[]>) => {
                let arrayusers = res.body ?? [];

                if (arrayusers.length > 0) {
                    this.dadosUsuario = arrayusers[0];
                    if ([38, 39].indexOf(this.dadosUsuario.id) > -1) {
                        this.isSancorClientes = true;
                    }

                    this.errors = null;
                } else {
                    // alert('Por favor, complete seus dados para efetuar compras.')
                    // this.router.navigate(['/meus-dados']);

                    this.dadosUsuario = {};
                }
            },
            error => {
                this.errors = error;
            }
        );
    }
}
